import { fetchAPI } from './apiUtils';
export const REPORT_URL = 'api/v2/user';

export function getReportData(params) {
  return fetchAPI(`${REPORT_URL}/user_catering_orders`, 'GET', null, params);
}

export function deleteReportMethod(id) {
  return fetchAPI(REPORT_URL + id, 'DELETE');
}
